import { Row, Col, Select, Image } from 'antd';
import { EventEmitter } from 'events';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { TECHNIC_PREFIX } from '../../../config/technicPrefix';
import { urls } from '../../../config/url';
import { Job2Status } from '../../../redux/progress/job2/job2Interface';
import { ILine } from '../../../redux/progress/line/lineReducer';
import { IModuleInfo } from '../../../redux/progress/module/moduleInterface';
import { IState } from '../../../redux/store';
import httpRequest from '../../../utils/HttpRequest';
import GetJobStatu from './getJobStatu';
import ResponseAction from './response-action';
import { useProgressImageShow } from './easyRealTime/imageShow';

export interface RealTimeImageViewerProps {
    userName: string,
    activeProjectName: string,
    line: ILine,
    module: IModuleInfo,
    scroll?: number,
    setScroll?: (scroll: number) => void,
    jobStatu: Job2Status,
    position: string
}

class ImageLoader extends EventEmitter {
    private _stop = false;
    private _urls: string[] = [];

    get urls() {
        return this._urls;
    }

    constructor(private readonly files: { filenames: string[], filepath: string }) {
        super();
        this.load(files);
    }


    load = async (files: { filenames: string[], filepath: string }) => {
        for (let index = 0; index < files.filenames.length; index++) {
            if (this._stop) return;
            const filename = files.filenames[index];

            var response = await httpRequest(urls.getImageBlob, {
                FILEPATH: `${files.filepath}/${filename}`,
            }, { responseType: 'blob' });
            this._urls.push(URL.createObjectURL(response.data));
            this.emit('onUpdate', this._urls.concat());
        }
    }

    addListener(event: 'onUpdate', listener: (urls: string[]) => void): this;
    addListener(event: string | symbol, listener: (...args: any[]) => void): this {
        return super.addListener(event, listener);
    }

    stop() {
        this.removeAllListeners();
        this._stop = true;
    }
}

function RealTimeImageViewer(props: RealTimeImageViewerProps) {


    const { tech } = useParams<{ spec: string, tech: string }>();
    const [timeSlices, setTimeSelices] = useState<{
        qcfilepath: string,
        filenames: string[]
    }>();
    const [currentSlice, setCurrentSlice] = useState();

    const [files, setfiles] = useState<{ filenames: string[], filepath: string }>();
    const [imageUrls, setImageUrls] = useState<string[]>([])
    const scrollRef = useRef<HTMLDivElement>(null);
    const [imgPath, setImgPath] = useState({
        filenames: [] as string[],
        qcfilepath: ""
    });

    const [imgs, setImgs] = useState([] as {
        src: string,
        width: number,
        height: number,
    }[]);
    const [show, showJsx] = useProgressImageShow(imgs, imgPath);
    useEffect(() => {
         
        if (props.scroll && scrollRef && scrollRef.current) {
            scrollRef.current.scrollTop = (scrollRef.current.scrollHeight - scrollRef.current.offsetHeight) * props.scroll / 100;
        }
    }, [props.scroll, scrollRef])

    useEffect(() => {
        
        
        if (!(props.activeProjectName && props.line.activeName && props.module && props.userName)) return;
        // if(props.jobStatu !== Job2Status.complete) return;

        httpRequest(urls.realtimeqcdirs, {
            USER_NAME: props.userName,
            PROJECTNAME: props.activeProjectName,
            proj_name: props.line.activeName,
            PRO_MODULE_NAME: props.module.PRO_MODULE_NAME,
            TECHNIC_PREFIX: (TECHNIC_PREFIX as any)[tech],
            FLOWTYPE: 'realtime',
        }).then(res => {
            try {
                const data = ResponseAction(res);
                
                setTimeSelices(data);
                if (props.position == 'left') {
                    setCurrentSlice(data.filenames[data.filenames.length - 1]);
                } else {
                    setCurrentSlice(data.filenames[0]);

                }
                
            } catch {

            }
        })
    }, [props.activeProjectName, props.line.activeName, props.module, props.userName, tech,props.jobStatu]);


    

    useEffect(() => {
        if (!(props.activeProjectName && props.line.activeName && props.module && props.userName && currentSlice)) return;
      
        
        httpRequest(urls.realtimeqcfile, {
            USER_NAME: props.userName,
            PROJECTNAME: props.activeProjectName,
            proj_name: props.line.activeName,
            PRO_MODULE_NAME: props.module.PRO_MODULE_NAME,
            TECHNIC_PREFIX: (TECHNIC_PREFIX as any)[tech],
            FLOWTYPE: 'realtime',
            timeslice: currentSlice,
        }).then(res => {
            try {
                const data = ResponseAction(res);
                setfiles(data);
                setImgPath(data);
            } catch {

            }
        })

    }, [currentSlice, tech, props.activeProjectName, props.line.activeName, props.module, props.userName,props.jobStatu]);

    useEffect(() => {
        if (!files) return;
        const currentLoader = new ImageLoader(files);
        
        currentLoader.addListener('onUpdate', (imageUrls) => {
            let arr: any = []
            imageUrls && imageUrls.map((item, i) => {
                arr.push({
                    src: item,
                    width: 900,
                    height: 2300,
                })
            })
            setImageUrls(imageUrls)
            setImgs(arr)
        });
        return () => {
            currentLoader.stop();
        }
    }, [files]);


    return <Row style={{ border: '1px solid #dcdfe5', padding: '5px' }}>
        <Col span={12} offset={10}>
            <Row gutter={5}>
                <Col span={12} style={{ textAlign: 'end', fontWeight: 'bolder' }}>
                    <label> 时间片：</label>
                </Col>
                <Col span={12}>
                    <Select value={currentSlice} onChange={e => setCurrentSlice(e)} style={{ width: '100%' }} >
                        {timeSlices?.filenames.map((slice) => {
                            return <Select.Option value={slice}>{slice}</Select.Option>
                        })}
                    </Select>
                </Col>
            </Row>
        </Col>
        <Col span={24} style={{ maxHeight: '500px', overflow: 'hidden' }} ref={scrollRef} onScroll={e => {
            // e.currentTarget.scrollTop = 123;
            // console.log(e.currentTarget.scrollTop);
            // if (props.setScroll) {
            //     props.setScroll(e.currentTarget.scrollHeight/ e.currentTarget.scrollTop*100);
            // }
        }}>
            <Image.PreviewGroup>
                {imageUrls.map((url, i) => <Image width={"90%"} src={url} preview={false} onClick={() => {
                    show(i);
                }}/> )}
            </Image.PreviewGroup>
        </Col>
        {showJsx}
    </Row>
}


const mapStateToProps = (state: IState) => {
    const module = state.progress.modules.modules[state.progress.modules.activeIndex];
    return {
        jobStatu: GetJobStatu(state),
        module: module,
        qualityControl: state.progress.qualityControl,
        // jobs: state.progress.jobs,
        userName: state.user.userName,
        activeProjectName: state.project.activeName,
        line: state.progress.line,
        job2s: state.progress.job2s,
        params: state.progress.params,

    };
};

export default connect(
    mapStateToProps
)(RealTimeImageViewer);
